<template>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-12">
      <h4>{{ $t('src/components/coursepinsmartphone.5896') }}</h4>
    </div>
    <div v-if="smartphone" class="col-lg-6 col-md-6 col-12">
      <div class="alert alert-outline-primary alert-smartphone">
        {{ smartphoneParsed.manufacturer }}
        <span class="text-nowrap">{{ smartphoneParsed.model }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoursePinSmartphone',
  props: {
    smartphone: {
      type: String,
      required: false
    }
  },
  data: () => ({}),
  computed: {
    smartphoneParsed() {
      if (!this.smartphone) {
        return {
          manufacturer: this.$t('deviceStatus.unknown'),
          model: ''
        }
      }
      return JSON.parse(this.smartphone)
    },
    name() {
      return this.smartphoneParsed.manufacturer + ' ' + this.smartphoneParsed.model
    }
  }
}
</script>
